import router from "../../../router";

export const index = (state) => state.index;
